/// <reference path="../typings/index.d.ts" />
/// <reference path="CloneData.d.ts" />

namespace App {
    export class CloneData implements ICloneData {
        public inicializarCampo(el: any, min: number, max: number, mainContainerId: string = 'main-container', cloneContainerClass: string = 'container-item', removeButtonClass: string = 'remove-item', optionsSelectTag: any = null, metodoAposAdd: any = () => {}, metodoAposRemover: any = () => {}): void {
            el.cloneData({
                parent: 'fieldset',
                elementoAdd: el,
                mainContainerId: mainContainerId, // Main container Should be ID
                cloneContainer: cloneContainerClass, // Which you want to clone
                removeButtonClass: removeButtonClass, // Remove button for remove cloned HTML
                removeConfirm: false, // default true confirm before delete clone item
                removeConfirmMessage: 'Are you sure want to delete?', // confirm delete message
                //append: '<a href="javascript:void(0)" class="remove-item btn btn-sm btn-danger remove-social-media">Remove</a>', // Set extra HTML append to clone HTML
                minLimit: min, // Default 1 set minimum clone HTML required
                maxLimit: max, // Default unlimited or set maximum limit of clone HTML
                defaultRender: 1, // Number of clone items rendered by default
                optionsSelectTag: optionsSelectTag,
                init: function () {
                },
                beforeRender: function () {
                },
                afterRender: metodoAposAdd,
                afterRemove: metodoAposRemover,
                beforeRemove: function () {
                }
            });
        }
    }
}
